import { createSelector } from 'reselect';

export const selectServicesState = ({ services }) => services;

const selectServicesConfig = createSelector(selectServicesState, ({ config } = {}) => config);

const selectEditModeConfig = createSelector(selectServicesConfig, ({ editMode } = {}) => editMode);

const selectServiceName = createSelector(
  selectServicesConfig,
  ({ serviceName } = {}) => serviceName,
);

export const selectReviewFormConfig = createSelector(
  selectServicesConfig,
  ({ ReviewForm = {} } = {}) => ReviewForm,
);

const selectErrorConfig = createSelector(selectServicesConfig, (config) => config.errorConfig);

const selectAppointmentTypeNotFound = createSelector(
  selectErrorConfig,
  (errorConfig) => errorConfig?.selectAppointmentTypeNotFound || undefined,
);

const selectPartnersNotFoundError = createSelector(
  selectErrorConfig,
  (errorConfig) => errorConfig?.selectPartnersNotFoundError || undefined,
);

const selectCalendarConfig = createSelector(
  selectServicesConfig,
  (config) => config.Calendar || {},
);

export const servicesSelectors = {
  selectServicesConfig,
  selectEditModeConfig,
  selectServiceName,
  selectErrorConfig,
  selectAppointmentTypeNotFound,
  selectPartnersNotFoundError,
  selectCalendarConfig,
  selectReviewFormConfig,
};
